import { axios } from '../config/axios';

const endPoint = 'project/violations/';

const getAll = () => {
    return axios.get(`${endPoint}`);
}

export { getAll };
